import script from "./NewProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProduct.vue?vue&type=script&setup=true&lang=js"

import "./NewProduct.vue?vue&type=style&index=0&id=4aae8e62&lang=css"

const __exports__ = script;

export default __exports__